import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ValAddTwoDropDownData } from './valaddtwo-drop-down-model';

export class ValAddTwoDropDownDataResponseModel extends GlobalResponseObject{
    data?: ValAddTwoDropDownData[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data //ValAddTwoDropDownData[]
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: ValAddTwoDropDownData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }
}
